import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Link,
  Typography,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { useHistory } from "react-router";

import ConciergeCircle from "assets/images/icons/concierge-circle.svg";
import { CUSTOMER_SUPPORT_EMAIL } from "helpers/constants";
import useCatalogDetail from "hooks/useCatalogDetail";

interface ConfirmDialogProps {
  open?: boolean;
  onClose?: () => void;
  requisitionId?: string;
  isCatalog?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: 560,
  },
  actions: {
    "& > button": {
      margin: "0 8px",
    },
  },
  divider: {
    backgroundColor: theme.palette.grey[500],
  },
  customerSupport: {
    fontWeight: 400,
    fontSize: 10,
    lineHeight: "14.58px",
    letterSpacing: 1,
  },
}));

export const QuoteConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open = false,
  onClose = () => {},
  requisitionId = "",
  isCatalog = false,
}) => {
  const history = useHistory();
  const classes = useStyles();

  const { isDraftCustomPanel } = useCatalogDetail();

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      classes={{ paper: classes.container }}
    >
      <DialogTitle>
        <Typography variant="h2" align="center">
          Request quote confirmed
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <img
            width={80}
            height={80}
            src={ConciergeCircle}
            alt="Concierge Bell"
          />
          <Box mt={3} mb={1}>
            <Typography variant="h5" component="h3">
              Requisition {requisitionId}
            </Typography>
          </Box>
          <Typography variant="body1" align="center">
            A sales representative will contact you within 24 hours regarding
            your quote request.
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            my={3}
            className={classes.actions}
          >
            {isDraftCustomPanel && (
              <Button
                onClick={() => history.push("/dashboard/draft-custom-panels")}
              >
                Return to drafts
              </Button>
            )}
            {!isCatalog && !isDraftCustomPanel && (
              <Button onClick={onClose}>Request more quotes</Button>
            )}
            {isCatalog && !isDraftCustomPanel && (
              <Button onClick={() => history.push("/catalog")}>
                Browse catalog
              </Button>
            )}
            <Button
              variant="outlined"
              onClick={() => history.push("/dashboard/quotes")}
            >
              My account
            </Button>
          </Box>
          <Box width={1}>
            <Divider className={classes.divider} />
          </Box>
          <Box mt={3} mb={2}>
            <Typography className={classes.customerSupport} align="center">
              If you have any questions or concerns, please contact{" "}
              <Link
                color="primary"
                target="_top"
                href={`mailto:${CUSTOMER_SUPPORT_EMAIL}`}
                underline="hover"
              >
                Customer Support.
              </Link>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
